export const AlternateCalendarSVG = () => {
  return (
    <svg
      id="alt-calendar-icon"
      className="scale-125"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.5 20C4.67267 20 4 19.3273 4 18.5V7.5C4 6.67267 4.67267 6 5.5 6H8V4.5C8 4.224 8.224 4 8.5 4C8.776 4 9 4.224 9 4.5V6H15V4.5C15 4.224 15.224 4 15.5 4C15.776 4 16 4.224 16 4.5V6H18.5C19.3273 6 20 6.67267 20 7.5V18.5C20 19.3273 19.3273 20 18.5 20H5.5ZM5 18.5C5 18.776 5.224 19 5.5 19H18.5C18.776 19 19 18.776 19 18.5V11H5V18.5ZM19 10V7.5C19 7.224 18.776 7 18.5 7H16V8C16 8.276 15.776 8.5 15.5 8.5C15.224 8.5 15 8.276 15 8V7H9V8C9 8.276 8.776 8.5 8.5 8.5C8.224 8.5 8 8.276 8 8V7H5.5C5.224 7 5 7.224 5 7.5V10H19Z"
        fill="#3C4D6A"
      />
    </svg>
  );
};
